import get from 'lodash-es/get';

export function trackBy(path: string[] = []) {
  return (index: number, element: any) => {
    return get(element, path);
  };
}
